import { loadable } from 'ha/helpers/nextjs/loadable';

export const LoadableHermesNotFoundPage = loadable(() => {
  return import(
    /* webpackChunkName: "LoadableHermesNotFoundPage" */ './HermesNotFoundPage'
  );
});
